var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHidePassword = function SvgHidePassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.547 7.107a1 1 0 1 0-1.414-1.414L5.547 17.279a1 1 0 1 0 1.414 1.414L18.547 7.107ZM3.89 14.38c.364.391 1.354.374 1.731-.004l6.89-6.889c.554-.555.274-1.681-.51-1.697h-.16C6.646 5.923 2.54 10.608 2.54 12c0 .502.447 1.408 1.35 2.38ZM11.478 17.005c-.367.367-.157 1.265.362 1.265 5.5 0 9.4-4.973 9.4-6.284 0-.69-.759-1.61-1.391-2.386-.35-.429-.99.023-1.38.414l-6.991 6.99Z",
    fill: "currentColor"
  })));
};
export default SvgHidePassword;